(() => {
  const container = document.querySelector('.shopify-policy__container');
  if (!container) return;

  document.body.classList.add('pv-policy-page');

  const path = window.location.pathname.toLowerCase();
  const titleWrap = container.querySelector('.shopify-policy__title');
  const bodyWrap = container.querySelector('.shopify-policy__body');
  const content = bodyWrap?.querySelector('.rte') || bodyWrap;
  if (!titleWrap || !bodyWrap || !content) return;

  const profiles = {
    '/policies/privacy-policy': {
      eyebrow: 'Privacidad y datos personales',
      intro: 'Conoce cómo recopilamos, utilizamos y protegemos la información relacionada con tu experiencia en PRONAVID.'
    },
    '/policies/terms-of-service': {
      eyebrow: 'Condiciones de uso y compra',
      intro: 'Consulta las condiciones que regulan el uso de nuestro sitio, los pedidos y los servicios disponibles en la tienda.'
    },
    '/policies/shipping-policy': {
      eyebrow: 'Entregas, cobertura y tiempos',
      intro: 'Revisa las condiciones de preparación, despacho y entrega aplicables a los pedidos realizados en nuestra tienda.'
    }
  };

  const profile = profiles[path] || {
    eyebrow: 'Información legal',
    intro: 'Consulta la información vigente aplicable al uso de nuestra tienda y a los servicios de PRONAVID.'
  };

  const heading = titleWrap.querySelector('h1');
  const eyebrow = document.createElement('p');
  eyebrow.className = 'pv-policy-eyebrow';
  eyebrow.textContent = profile.eyebrow;
  titleWrap.prepend(eyebrow);

  const intro = document.createElement('p');
  intro.className = 'pv-policy-intro';
  intro.textContent = profile.intro;
  titleWrap.append(intro);

  const progress = document.createElement('div');
  progress.className = 'pv-policy-progress';
  progress.setAttribute('aria-hidden', 'true');
  document.body.append(progress);

  const toolbar = document.createElement('div');
  toolbar.className = 'pv-policy-toolbar';
  toolbar.innerHTML = `
    <nav class="pv-policy-breadcrumbs" aria-label="Migas de pan">
      <a href="/">Inicio</a>
      <span aria-hidden="true">/</span>
      <span>${heading?.textContent?.trim() || 'Política'}</span>
    </nav>
    <div class="pv-policy-actions">
      <button class="pv-policy-action" type="button" data-policy-print>
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 8V4h10v4"></path><path d="M6 18H4V9h16v9h-2"></path><path d="M7 14h10v6H7Z"></path></svg>
        <span>Imprimir</span>
      </button>
    </div>`;
  titleWrap.insertAdjacentElement('afterend', toolbar);
  toolbar.querySelector('[data-policy-print]')?.addEventListener('click', () => window.print());

  const headings = [...content.querySelectorAll('h2, h3')].filter((item) => item.textContent.trim());
  const usedIds = new Set();
  const slugify = (value) => {
    const base = value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'seccion';
    let id = base;
    let index = 2;
    while (usedIds.has(id) || document.getElementById(id)) id = `${base}-${index++}`;
    usedIds.add(id);
    return id;
  };

  if (headings.length >= 2) {
    const toc = document.createElement('aside');
    toc.className = 'pv-policy-toc';
    toc.setAttribute('aria-label', 'Contenido de la política');
    const list = document.createElement('ol');

    headings.forEach((item) => {
      if (!item.id) item.id = slugify(item.textContent.trim());
      const li = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${item.id}`;
      link.textContent = item.textContent.trim();
      if (item.tagName === 'H3') link.style.paddingLeft = '1.6rem';
      li.append(link);
      list.append(li);
    });

    toc.innerHTML = '<p class="pv-policy-toc__title"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 6h14M5 12h14M5 18h9"></path></svg>En esta página</p>';
    toc.append(list);
    bodyWrap.prepend(toc);

    const links = [...toc.querySelectorAll('a')];
    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
      if (!visible) return;
      links.forEach((link) => link.classList.toggle('is-active', link.hash === `#${visible.target.id}`));
    }, { rootMargin: '-20% 0px -68% 0px', threshold: [0, 1] });
    headings.forEach((item) => observer.observe(item));
  } else {
    bodyWrap.classList.add('is-single-column');
  }

  const help = document.createElement('section');
  help.className = 'pv-policy-help';
  help.innerHTML = `
    <div>
      <strong>¿Necesitas aclarar alguna información?</strong>
      <span>Nuestro equipo de atención al cliente puede orientarte sobre compras, entregas y uso de la tienda.</span>
    </div>
    <div class="pv-policy-help__links">
      <a href="mailto:atencionalcliente@grupoprocasty.com">Escribir por correo</a>
      <a href="tel:+50422768888">+504 2276-8888</a>
    </div>`;
  container.append(help);

  const updateProgress = () => {
    const rect = container.getBoundingClientRect();
    const scrollable = Math.max(container.offsetHeight - window.innerHeight, 1);
    const traveled = Math.min(Math.max(-rect.top, 0), scrollable);
    progress.style.width = `${(traveled / scrollable) * 100}%`;
  };
  updateProgress();
  window.addEventListener('scroll', updateProgress, { passive: true });
  window.addEventListener('resize', updateProgress);
})();
